
import { EntityConfig } from './types';
import { ENTITY_CONFIGS } from './registry';

/**
 * Get configuration for a specific entity type
 */
export const getEntityConfig = (entityType: string): EntityConfig => {
  const config = ENTITY_CONFIGS[entityType];
  if (!config) {
    throw new Error(`Unsupported entity type: ${entityType}. Supported types: ${Object.keys(ENTITY_CONFIGS).join(', ')}`);
  }
  return config;
};

/**
 * Register a new entity type configuration
 */
export const registerEntityType = (entityType: string, config: EntityConfig): void => {
  ENTITY_CONFIGS[entityType] = config;
};

/**
 * Get all supported entity types
 */
export const getSupportedEntityTypes = (): string[] => {
  return Object.keys(ENTITY_CONFIGS);
};

/**
 * Get display name for an entity type
 */
export const getEntityDisplayName = (entityType: string): string => {
  const config = ENTITY_CONFIGS[entityType];
  return config?.displayName || entityType.charAt(0).toUpperCase() + entityType.slice(1);
};
